import _initializerDefineProperty from "@babel/runtime-corejs3/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime-corejs3/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime-corejs3/helpers/initializerWarningHelper";
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
import { action, observable, when } from 'mobx';
import { useFeatureVariantAssignmentsQuery } from '@udemy/graphql';
import { QUERIES_BY_USE_CASE, ProgramEnrollmentStore } from '@udemy/react-subscription-experience';
import { noop } from '@udemy/shared-utils';
import { udApi } from '@udemy/ud-api';
import { useEnrolledCoursesMyLearningHeaderQuery } from '../../graphql/api-platform-graphql';
import { COURSE_PAGE_SIZE, PROGRAM_PAGE_SIZE } from './constants';
export let MyLearningStore = (_dec = observable.ref, _dec2 = observable.ref, _class = class MyLearningStore {
  constructor(headerStore) {
    _initializerDefineProperty(this, "isLoading", _descriptor, this);
    _initializerDefineProperty(this, "courses", _descriptor2, this);
    _initializerDefineProperty(this, "programs", _descriptor3, this);
    this.headerStore = void 0;
    this.programEnrollmentStore = void 0;
    this.loadPromise = void 0;
    this.isGraphQLRoutingEnabled = void 0;
    _initializerDefineProperty(this, "loadMyLearningContent", _descriptor4, this);
    this.headerStore = headerStore;
    this.programEnrollmentStore = new ProgramEnrollmentStore();
    this.isGraphQLRoutingEnabled = this.fetchGraphQLRoutingEnabled();
  }
  async fetchGraphQLRoutingEnabled() {
    try {
      var _featureVariantAssign, _featureVariantAssign2;
      const featureVariantAssignmentsQuery = await useFeatureVariantAssignmentsQuery.fetcher({
        featureCodes: ['graphql_routing_for_frontends']
      })();
      return (_featureVariantAssign = (_featureVariantAssign2 = featureVariantAssignmentsQuery.featureVariantAssignmentsByFeatureCodes.find(feature => {
        return feature.featureCode === 'graphql_routing_for_frontends';
      })) === null || _featureVariantAssign2 === void 0 || (_featureVariantAssign2 = _featureVariantAssign2.configuration) === null || _featureVariantAssign2 === void 0 ? void 0 : _featureVariantAssign2.react_header) !== null && _featureVariantAssign !== void 0 ? _featureVariantAssign : false;
    } catch (error) {
      return false;
    }
  }
  get user() {
    return this.headerStore.userSpecificContext.user;
  }
  loadPrograms() {
    if (this.user.sms_subscriptions_active) {
      return this.programEnrollmentStore
      // Using PROGRAM_ENROLLMENTS because the result is likely cached
      .queryProgramEnrollments(QUERIES_BY_USE_CASE.PROGRAM_ENROLLMENTS).then(() => this.programEnrollmentStore.programCardData.slice(0, PROGRAM_PAGE_SIZE)).catch(noop);
    }
    return Promise.resolve();
  }
  async fetchCoursesWithGraphQL() {
    var _gqlResponse$me;
    const gqlResponse = await useEnrolledCoursesMyLearningHeaderQuery.fetcher({
      page: 0,
      pageSize: COURSE_PAGE_SIZE
    })();
    const gqlResults = ((_gqlResponse$me = gqlResponse.me) === null || _gqlResponse$me === void 0 || (_gqlResponse$me = _gqlResponse$me.enrollments) === null || _gqlResponse$me === void 0 ? void 0 : _gqlResponse$me.courseEnrollments) || [];
    return gqlResults.filter(enrollment => !!enrollment).map(enrollment => {
      return {
        id: enrollment.course.id,
        image_240x135: enrollment.course.images.px240x135,
        title: enrollment.course.title,
        completion_ratio: enrollment.completionPercentage
      };
    });
  }
  async loadCourses() {
    const myCoursesUrl = this.user.consumer_subscription_active ? '/users/me/subscription-course-enrollments/' : '/users/me/subscribed-courses/';
    const params = {
      page_size: COURSE_PAGE_SIZE,
      ordering: '-last_accessed',
      'fields[course]': 'image_240x135,title,completion_ratio'
    };
    if (!this.user.consumer_subscription_active) {
      params.is_archived = false;
    }

    // TODO: COS-1093 Remove experiment call once we verify experience is working as expected
    if (await this.isGraphQLRoutingEnabled) {
      try {
        const courses = await this.fetchCoursesWithGraphQL();
        // Return early if GraphQL succeeds, otherwise wait for Monolith
        return {
          data: {
            results: courses
          }
        };
      } catch (result) {
        noop(result);
      }
    }
    try {
      return await udApi.get(myCoursesUrl, {
        params
      });
    } catch (result) {
      return noop(result);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "courses", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "programs", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "loadMyLearningContent", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return () => {
      if (this.loadPromise) {
        return this.loadPromise;
      }
      this.loadPromise = when(() => !!this.user).then(() => Promise.all([this.loadPrograms(), this.loadCourses()])).then(action(([programsResponse, coursesResponse]) => {
        if (programsResponse) {
          this.programs = programsResponse;
        }
        if (coursesResponse) {
          this.courses = coursesResponse.data.results || [];
        }
        this.isLoading = false;
      })).catch(action(() => {
        this.isLoading = false;
      }));
      return this.loadPromise;
    };
  }
}), _class);
//# sourceMappingURL=my-learning.mobx-store.js.map